<template>
  <div class="c-annotator__wrapper annotator-outer annotator-editor annotator-hide">
    <form class="c-annotator__widget annotator-widget">
        <a href="#cancel" class="c-annotator__cancel annotator-cancel"></a>
        <div class="c-annotator__heading">
          <edit-icon class="c-annotator__icon"></edit-icon>
          <span class="c-annotator__heading-text"></span>
        </div>
        <ul class="c-annotator__listing annotator-listing" @init="load()">
        </ul>
        <div class="c-annotator__controls">
            <a href="#delete" class="c-annotator__btn annotator-delete hide">{{ $t('DELETE') }}</a>
            <a href="#save" class="c-annotator__btn annotator-save annotator-focus">{{ $t('SAVE') }}</a>
        </div>
    </form>
  </div>
</template>

<script>
import NoteEdit from '@/assets/svg/NoteEdit'

export default {
  name: 'BookPageNoteEditor',

  components: {
    'edit-icon': NoteEdit
  },

  async mounted () {
    this.load()
  },

  props: {
    pageId: String
  },

  computed: {
    currentPageEditor() {
      return document.querySelectorAll(`.annotator-outer.annotator-editor`)[this.pageId === 'page_1' ? 0 : 1]
    }
  },

  methods: {
    load () {
      setTimeout(() => {
        if(!this.currentPageEditor) return
        const textarea = this.currentPageEditor.querySelector('.c-annotator__listing .annotator-item textarea')

        textarea.removeAttribute('placeholder')
      }, 100)
    }
  }
}
</script>

<style lang="scss">
.c-annotator__listing {
  .annotator-item {
    &:first-child {
      textarea {
        background: #fff;
        border-radius: 10px;
        min-height: 11em;
        &:focus,
        &:active {
          background: #fff;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
@import '@/assets/scss/_vars.scss';

.hide {
  display: none;
}
.c-annotator__icon {
  vertical-align: middle;
}
.c-annotator__widget {
  background: $annotator_widget;
  border: none;
  padding: 0 10px 6px;
  min-width: 365px;
  box-shadow: none;
  border-radius: 8px;
  margin-left: -164px;
}
.c-annotator__wrapper.annotator-editor {
  margin-left: -105px;
  &.annotator-invert-x {
    margin-left: 55px;
  }
}


.c-annotator__widget:after {
  left:calc(50% - 9px);
  background: $annotator_widget;
  transform: rotate(45deg);
  height: 18px;
}
.c-annotator__wrapper.annotator-invert-y {
  .c-annotator__widget {
    &:after {
      height: 18px;
    }
  }
}
.c-annotator__heading {
  text-align: center;
  font-size: 14px;

  span {
    color: $dark-blue;
    vertical-align: middle;
    padding-left: 3px;
  }
}

.c-annotator__cancel {
  position: absolute;
  top: 1rem;
  right: 0;

  text-shadow: none;
  box-shadow: none;
  border: 0;
  font-size: 1rem;
}
.c-annotator__controls {
  background: transparent;
  border: none;
  box-shadow: none;
  text-align: center;
  margin-top: 6px;

  .c-annotator__btn {
    background: $white;
    border-radius: 20px;
    padding: 4px 25px;
    border-color: $dark-blue;
    margin-right: 16px;
    text-shadow: none;
    box-shadow: none;
    border-width: 2px;
    font-size: 12px;
    font-weight: 300;
    line-height: 14px;
    z-index: 1;

    &--single-btn {
      margin-right: 0;
    }

    &.annotator-save {
      background: $dark-blue;
      color: $white;
      &:hover {
        color: $white;
      }
    }

    &:hover,
    &:active {
      text-shadow: none;
      color: $dark-blue
    }
    &:after {
      background-image: none;
    }
  }
}
</style>
